import { z } from 'zod'

export const ReviewDogInfoSchema = z.object({
	breed: z.string().uuid(),
	age: z.string().uuid(),
	userId: z.string().uuid().nullable().optional(),
})

export type ReviewDogInfoSchema = z.infer<typeof ReviewDogInfoSchema>

export const ReviewDogInfoSerializer = {
	serialize: (dogInfo: ReviewDogInfoSchema) => JSON.stringify(ReviewDogInfoSchema.parse(dogInfo)),
	unserialize: (json: string) => ReviewDogInfoSchema.parse(JSON.parse(json)),
}
